import { render, staticRenderFns } from "./ProviderDetails.vue?vue&type=template&id=5830424d&scoped=true&"
import script from "./ProviderDetails.vue?vue&type=script&lang=js&"
export * from "./ProviderDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProviderDetails.vue?vue&type=style&index=0&id=5830424d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5830424d",
  null
  
)

export default component.exports